<template>
  <section>
    <div v-if="loading" class="loading">
      <mo-loader :loading="loading"></mo-loader>
    </div>
    <ba-table v-if="items.rows && items.rows.length && !loading">
      <template v-if="items.rows && items.rows.length" slot="body">
        <tr v-for="row in items.rows" :key="row.id">
          <td />
          <td>
            <span v-if="!row.active" class="tooltip-container">
              <ab-icon icon="eye" />
              <div class="tooltip">
                {{ $t("action.readPast") }}
              </div>
            </span>
          </td>

          <td>
            <div>N° {{ row.Request.label }}</div>
            <div>N° {{ row.commande_id }}</div>
          </td>

          <td v-if="isNotification">
            {{ dateCreateNotif(row.createdAt) | dateNotification }}
          </td>

          <td v-if="!isNotification">
            {{ format(new Date(row.createdAt), "DD/MM/YYYY") }}
          </td>

          <td v-if="isNotification">
            {{ row.Notification_type.label }}
          </td>

          <td v-if="isNotification">
            <div>{{ splitSupplierInfos(row).fournisseur }}</div>
            <div>{{ splitSupplierInfos(row).infos }}</div>
          </td>

          <td v-if="!isNotification">
            <div>{{ displaySeller(row) }}</div>
            <div>{{ row.NotificationAlertType.label }}</div>
          </td>

          <td>
            <span class="tooltip-container" @click="handleRequestRoute(row)">
              <ab-icon icon="request" />
              <div class="tooltip">
                {{ $t("page.dashboard.modalRedirection.goToRequest") }}
              </div>
            </span>

            <span class="tooltip-container" @click="handleCommandRoute(row)">
              <ab-icon icon="commande" />
              <div class="tooltip">
                {{ $t("page.dashboard.modalRedirection.goToCommand") }}
              </div>
            </span>

            <span class="tooltip-container delete-notif" @click.stop="showModal(row.id)">
              <ab-icon icon="bin" />
              <div class="tooltip">
                {{ $t("action.delete") }}
              </div>
            </span>
          </td>
        </tr>
      </template>

      <template slot="head">
        <tr>
          <th v-for="(col, index) in filteredCols" :key="index" :class="[col.class, col.sortable ? 'sortable' : '']"
            @click="sortby(index)">
            <span>
              {{ col.label }}
              <ab-icon v-if="col.sortable && ordercol(index)" :icon="ordercol(index)" />
            </span>
          </th>
        </tr>
      </template>
    </ba-table>
    <div v-if="!items.rows || (!items.rows.length && !loading)">
      <p class="no-data">
        {{ $t("page.dashboard.noDataAvailable") }}
      </p>
    </div>

    <footer class="mt12">
      <paginate v-if="items.rows && items.rows.length && !loading" v-model="page" prev-class="prev" next-class="next"
        prev-text=" < " next-text=" > " :page-count="pageCount(items.rows, undefined, items.count)"
        :container-class="'mo-pagination'" />
    </footer>

    <modal class="modal" name="removeDocument" width="376px" @before-open="beforeOpen">
      <ba-card>
        <template slot="header">
          <span>{{ $t("page.dashboard.modal.title") }}</span>
        </template>
        <template>
          <p>{{ $t("page.dashboard.modal.body") }}</p>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button class="primary" @click.native="closeModal('removeDocument')">
              {{ $t("action.cancel") }}
            </ba-button>
            <ba-button class="danger" @click.native="deleteNotification">
              {{ $t("action.confirm") }}
            </ba-button>
          </div>
        </template>
      </ba-card>
    </modal>
  </section>
</template>

<script>
import { AbIcon, BaTable, BaCard, BaButton } from "@ab/basic-components";
import { format } from "date-fns";
import Paginate from "vuejs-paginate";
import sortableMixin from "@/components/mixins/sortable.js";
import paginationMixin from "@/components/mixins/pagination.js";
import { convertDateWithGMTNav } from "@/assets/js/helpers.js";
import { DASHBOARD_TABS, DASHBOARD_IDS } from "@/constants/dashboard";

export default {
  name: "DashboardList",
  components: {
    AbIcon,
    BaTable,
    BaCard,
    BaButton,
    Paginate
  },
  mixins: [
    sortableMixin,
    paginationMixin
  ],
  props: {
    tab: {
      type: String,
      default: DASHBOARD_TABS.NOTIFICATION
    },
    items: {
      type: Object,
      default: null
    },
    curPage: {
      type: Number,
      default: 1
    },
    cols: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      selectedRow: {},
      page: 1,
      DASHBOARD_TABS,
      DASHBOARD_IDS
    };
  },
  computed: {
    isNotification() {
      return this.tab === DASHBOARD_TABS.NOTIFICATION;
    },
    filteredCols() {
      // eslint-disable-next-line arrow-parens
      return this.cols.filter(col => {
        if (col.tab === undefined) return true;
        if (col.tab === DASHBOARD_IDS.NOTIFICATION && this.isNotification) {
          return true;
        }
        if (col.tab === DASHBOARD_IDS.ALERT && !this.isNotification) {
          return true;
        }
        return false;
      });
    }
  },
  watch: {
    page(value) {
      this.$emit("handle-page", value, this.tab);
    },
    curPage(value) {
      this.page = value;
    }
  },
  methods: {
    format,
    dateCreateNotif(d) {
      return convertDateWithGMTNav(d);
    },
    async handleRequestRoute(row) {
      await this.updateNotification(row.id);
      this.$modal.hide("detailsModal");
      this.$router.push({ name: "RequestEdit", params: { id: row.request_id } });
    },
    async handleCommandRoute(row) {
      await this.updateNotification(row.id);
      this.$modal.hide("detailsModal");
      this.$router.push({ name: "CommandeList", query: { id: row.commande_id } });
    },
    async updateNotification(id) {
      await this.$store.dispatch("updateNotification", { id });
    },
    async deleteNotification() {
      const data = await this.$store.dispatch("deleteNotification", {
        id: this.documentId,
        page: this.page,
        limit: Number(this.$store.getters.getLimit)
      });
      if (data && data.id) {
        this.$store.dispatch("displaySnackbar", {
          text: this.$t("page.dashboard.deletedNotification")
        });
      }
      this.closeModal("removeDocument");
    },
    splitSupplierInfos(row) {
      const { message } = row;
      if (message) {
        const s = message.split("Fournisseur : ");
        return {
          fournisseur: (s[1] && s[1].trim()) || "",
          infos: (s[0] && s[0].trim()) || ""
        };
      }
      return {
        fournisseur: "",
        infos: ""
      };
    },
    displaySeller(row) {
      if (row && row.Request && row.Request.InternalSeller && row.Request.InternalSeller.first_name && row.Request.InternalSeller.last_name) {
        return `${row.Request.InternalSeller.first_name} ${row.Request.InternalSeller.last_name}`;
      }
      return '';
    },
    beforeOpen(e) {
      this.documentId = e.params.id;
    },
    showModal(id) {
      this.$modal.show("removeDocument", { id });
    },
    closeModal(name) {
      this.$modal.hide(name);
      if (name === "removeDocument") {
        this.documentId = null;
      }
    },
    getData() {
      this.$emit("handle-page", this.page, this.tab);
    }
  }
};
</script>

<style scoped>
.mt12 {
  margin-top: 0.79rem;
  margin-bottom: 0.79rem;
}
.ab-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
<style src="@/assets/styles/tooltips.css"></style>
